<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="isDialogOpen"
    :lock-scroll="true"
    center
    @open="getAuth"
    @closed="resetForm"
  >
    <el-form
      ref="feeConfigEdit"
      :model="form"
      status-icon
      label-position="top"
      class="authForm"
      @submit.native.prevent
    >
      <el-form-item v-if="dialogMode === 'edit'">
        <span>姓名： {{ account.Name }}</span>
      </el-form-item>
      <el-form-item
        class="authBlock"
        label="權限"
      >
        <div class="highestAuth">
          <el-checkbox
            v-model="form.isAdmin"
            :disabled="dialogMode === 'edit'"
          />
          <div class="checkBoxLabel">
            <span class="pointer" @click="dialogMode === 'edit' ? '' : form.isAdmin = !form.isAdmin">最高權限管理者</span>
            <p v-if="dialogMode === 'open'" class="subText">
              可管理社區內所有社區管理人員帳號
            </p>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        class="featureBlock"
        label="人員功能管理"
      >
        <el-checkbox-group v-model="form.features">
          <el-checkbox
            v-for="item in features"
            :key="item.Id"
            class="feature"
            :label="item.Id"
          >
            {{ item.Name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        v-if="dialogMode === 'open'"
        class="noteBlock"
        label="注意事項"
      >
        <p>1.註銷序號請前往發放紀錄註銷</p>
        <p>2.開通序號需於1天內使用，一組序號僅可以開通一位管理者</p>
      </el-form-item>
    </el-form>
    <div class="divider" />
    <div
      v-if="dialogMode === 'open'"
      class="dialogFooter"
    >
      <el-button
        round
        :disabled="isSending"
        @click="getOpenCode"
      >
        產生序號
      </el-button>
      <el-input
        v-model="openCode"
        class="openCodeInput"
      />
    </div>
    <div
      v-if="dialogMode === 'edit'"
      class="dialogFooter"
    >
      <el-button
        round
        @click="editAuth"
      >
        儲存變更
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    account: Object
  },
  data () {
    return {
      dialogMode: '',
      isDialogOpen: false,
      form: {
        isAdmin: false,
        features: [1, 5, 7]
      },
      openCode: null,
      features: [],
      isSending: false
    }
  },
  computed: {
    dialogTitle () {
      switch (this.dialogMode) {
        case 'open':
          return '開通人員'
        case 'edit':
          return '編輯權限'
      }
    }
  },
  mounted () {
    this.getFeatures()
  },
  methods: {
    openDialog (mode) {
      this.dialogMode = mode
      this.isDialogOpen = true
    },
    getOpenCode () {
      if (!this.isSending) {
        this.isSending = true
        const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationSn`
        axios(url, {
          method: 'POST',
          headers: {
            kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
          },
          data: {
            Rule: this.form.isAdmin ? 'Admin' : 'User',
            FeatureIds: this.form.features
          }
        }).then(res => {
          this.isSending = false
          this.openCode = res.data.Data.Sn
        }).catch(err => {
          if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
            this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
              confirmButtonText: '確定',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false
            }).then(() => {
              this.$logoutCommunity()
            })
          }
          this.isSending = false
        })
      }
    },
    getAuth () {
      if (this.dialogMode === 'edit') {
        const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationAccounts/${this.account.Id}`
        axios(url, {
          method: 'GET',
          headers: {
            kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
          }
        }).then(res => {
          console.log(res.data.Data)
          this.form.isAdmin = res.data.Data.IsAdmin
          this.form.features = res.data.Data.Features.map(item => {
            return item.Id
          })
        }).catch(err => {
          console.log(err.response)
          if (err.response.status === 401 || !JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
            this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
              confirmButtonText: '確定',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false
            }).then(() => {
              this.$logoutCommunity()
            })
          }
        })
      }
    },
    editAuth () {
      const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationAccounts/${this.account.Id}`
      axios(url, {
        method: 'PUT',
        headers: {
          kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
        },
        data: {
          Feature: this.form.features.map(item => {
            return {
              Id: item
            }
          })
        }
      }).then(res => {
        this.isDialogOpen = false
      }).catch(err => {
        console.log(err.response)
        if (err.response.status === 401 || !JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
          this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$logoutCommunity()
          })
        }
      })
    },
    getFeatures () {
      const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationAccounts/Features`
      axios(url, {
        method: 'GET',
        headers: {
          kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
        }
      }).then(res => {
        this.features = res.data.Data.Features
      }).catch(err => {
        console.log(err.response)
      })
    },
    resetForm () {
      this.form = {
        isAdmin: false,
        features: [1, 5, 7]
      }
      this.openCode = null
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep .el-dialog__wrapper
  overflow: hidden
::v-deep .el-dialog
  +basicDialog
  overflow: auto
  max-height: 80%
  .el-dialog__body
    padding: 12px 0
    .authForm
      padding-left: 41px
      box-sizing: border-box
      .el-form-item
        margin-bottom: 39px
        padding-right: 0
        .el-form-item__label
          font-weight: bold
          padding-bottom: 0
        .highestAuth
          display: flex
          color: #333
          line-height: 1.2
          .checkBoxLabel
            margin-left: 7px
            .pointer
              cursor: pointer
        .subText
          color: #999999
          font-size: 15px
          margin-top: 4px
          &.note
            margin-bottom: 30px
        .feature
          margin-right: 35px
        .el-checkbox__label
          padding-left: 7px
          font-size: 15px
          font-weight: normal
          color: #333
        .noteBlock
          margin-bottom: 32px
    .divider
      border-top: 1px solid #cccccc
      margin: 0 23px
    .dialogFooter
      display: flex
      justify-content: center
      padding: 25px
      .openCodeInput
        width: 250px
        margin-left: 20px
</style>
